import { getTokenSocket, urlRealtimeLastVersion } from '../services/realTime';

// Refs globales para mantener la conexión y timeout
export const websocketRef = { current: null };
export const timeoutRef = { current: null };
export const isConnectingRef = { current: false }; // <--- agregado para evitar múltiples conexiones

export const getTokenSocketAux = async () => {
    try {
        const res = await getTokenSocket();
        if (res?.data?.token) {
            return `${urlRealtimeLastVersion}${res.data.token}`;
        }
    } catch (error) {
        console.error(" ❌ Error obteniendo el token:", error);
    }
    return null;
};

export const disconnectWebSocket = () => {
    console.log(" 💀 disconnectWebSocket");
    if (websocketRef.current) {
        websocketRef.current.onmessage = null;
        websocketRef.current.onopen = null;
        websocketRef.current.onclose = null;
        websocketRef.current.onerror = null;
        websocketRef.current.close();
        websocketRef.current = null;
        console.log(' ♻️ clean conection socket');
    }
    isConnectingRef.current = false;
};

/**
 * 🔒 CONNECT WEBSOCKET (con control para evitar conexiones duplicadas)
 */
export const connectWebSocket = async (message, stateHelper) => {
    // 🚫 Si ya hay un socket ABIERTO → usarlo y no reconectar
    if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
        console.log(" ⚠️ WebSocket ya estaba conectado. Reusando conexión existente.");
        if (message) {
            websocketRef.current.send(JSON.stringify(message));
        }
        return websocketRef.current;
    }
    // 🚫 Si ya se está conectando → evitar conexiones paralelas
    if (isConnectingRef.current) {
        console.log(" 🚫  Ya existe un intento de conexión en curso. Evitando duplicar conexiones.");
        return;
    }
    isConnectingRef.current = true;
    const uri = await getTokenSocketAux();
    if (!uri) {
        isConnectingRef.current = false;
        return;
    }
    const websocket = new WebSocket(uri);
    websocketRef.current = websocket;
    websocket.onopen = () => {
        console.log("Conectado al WebSocket");
        isConnectingRef.current = false;

        // Enviar mensaje solo después de abrir la conexión
        if (message) {
            console.log(" 📤 Payload enviado:", message);
            websocket.send(JSON.stringify(message));
        }
    };
    websocket.onmessage = (event) => {
        try {
            const ahora = new Date();
            const horaArgentina = ahora.toLocaleString("es-AR", {
                timeZone: "America/Argentina/Buenos_Aires",
                hour12: false
            });
            const msg = JSON.parse(event.data);
            stateHelper?.(msg);

            console.log(` 📩 Mensaje recibido del WebSocket:
(${horaArgentina})`, msg);
        }
        catch (e) {
            console.log("Mensaje recibido del WebSocket (Catch):", event.data);
        }
    };

    websocket.onerror = (error) => {
        console.error(" ❌ Error en WebSocket:", error);
    };

    websocket.onclose = (event) => {
        console.log(" 💀 Desconectado del WebSocket");
        isConnectingRef.current = false; // liberar estado de conexión
        stateHelper?.({
            status: 'disconnected',
            result: 'error'
        });
    };
    return websocket;
};

/**
 * Envia un mensaje directo (requiere socket abierto)
 */
export const sendMessage = (message) => {
    if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
        websocketRef.current.send(JSON.stringify(message));
        console.log(" 📤 Mensaje enviado:", message);
    } else {
        console.warn(" ❌ No estás conectado.");
    }
};

/**
 * 🧠 Envía mensaje garantizando conexión previa
 */
export const sendMessageWithConnect = async (message, stateHelper) => {
    // Si ya hay conexión activa → enviar directamente
    if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
        websocketRef.current.send(JSON.stringify(message));
        console.log(" 📤 Mensaje enviado (conexión existente):", message);
        return;
    }

    // Si está conectando → esperar a que abra
    if (websocketRef.current && websocketRef.current.readyState === WebSocket.CONNECTING) {
        console.log(" ⏳ Esperando a que el WebSocket se conecte...");
        await new Promise((resolve) => {
            const checkInterval = setInterval(() => {
                if (websocketRef.current?.readyState === WebSocket.OPEN) {
                    clearInterval(checkInterval);
                    websocketRef.current.send(JSON.stringify(message));
                    console.log(" 📤 Mensaje enviado tras conectar:", message);
                    resolve();
                }
            }, 200);
        });
        return;
    }

    // Si no hay conexión → crear una nueva y enviar cuando esté abierta
    console.log("🔌 🔴 No hay conexión activa, conectando antes de enviar...");
    await connectWebSocket(null, stateHelper);

    await new Promise((resolve, reject) => {
        let retries = 0;
        const maxRetries = 20; // ~4 segundos de espera máx.
        const checkInterval = setInterval(() => {
            if (websocketRef.current?.readyState === WebSocket.OPEN) {
                clearInterval(checkInterval);
                websocketRef.current.send(JSON.stringify(message));
                console.log(" 📤 Mensaje enviado tras reconexión:", message);
                resolve();
            } else if (retries++ > maxRetries) {
                clearInterval(checkInterval);
                console.error(" ❌ No se pudo abrir el WebSocket para enviar el mensaje.");
                reject(new Error("WebSocket no se conectó a tiempo."));
            }
        }, 200);
    });
};
